import { useMutation } from '@tanstack/react-query';

import type { RefundReasonMutationResponse } from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useRefundReasonActionMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<RefundReasonMutationResponse>({
        method: 'PATCH',
        url,
      }),
  });
